/* Blog Navita (sections/navita-artigo.liquid): índice "Neste artigo" a partir dos títulos H2 do texto (com âncoras),
   tira o emoji do início dos títulos, e o botão "Copiar link". */
(function () {
  const rte = document.querySelector('[data-nb-rte]');
  const toc = document.querySelector('[data-nb-toc]');
  if (rte && toc) {
    const lista = toc.querySelector('ol');
    let n = 0;
    rte.querySelectorAll('h2').forEach((h) => {
      // tira emojis e símbolos do início ("🌿 Algodão…" → "Algodão…")
      const limpo = h.textContent.replace(/^[^\p{L}\p{N}]+/u, '').trim();
      if (!limpo) { h.remove(); return; }
      if (h.textContent.trim() !== limpo) h.textContent = limpo;
      n += 1;
      if (!h.id) h.id = 'seccao-' + n;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = limpo;
      li.append(a);
      lista.append(li);
    });
    if (n >= 2) toc.hidden = false;
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-nb-copiar]');
    if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.nbCopiar); b.textContent = b.dataset.ok; } catch (erro) { window.prompt('', b.dataset.nbCopiar); }
  });
})();
